import React, { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";

import CheckboxLabel from "@busbud/design-system-components/dist/CheckboxLabel";
import LightningMD from "@busbud/design-system-components/dist/Icons/Lightning/MD";

import { useAppContext } from "@app/helpers/hooks";
import { getSelectedIsDirectOnly } from "@app/modules/results/selectors/get-selected-is-direct-only";
import {
  addIsDirectOnly,
  removeIsDirectOnly
} from "@app/modules/results/state/filters";

import { useFacetedSearch } from "../hooks/useFacetedSearch";

export const CheckboxIsDirect = () => {
  const { translator } = useAppContext();
  const dispatch = useDispatch();
  const selected_value = useSelector(getSelectedIsDirectOnly);
  const faceted_search = useFacetedSearch();
  const aggregation = faceted_search.getAggregation("is_direct_only");
  const bucket_data = aggregation?.buckets.find(
    bucket => bucket.key === "true"
  );
  const disabled = (bucket_data?.doc_count ?? 0) <= 0;
  const value = selected_value.includes(String(bucket_data?.key));
  const label = translator.t("!results.filters.quick.direct-only", {
    count: bucket_data?.doc_count || 0
  });

  const handleDirectOnlyCheckboxChange = useCallback(
    (key: string | number | undefined) => {
      const stringified_key = `${key}`;
      if (stringified_key) {
        selected_value.includes(stringified_key)
          ? dispatch(removeIsDirectOnly())
          : dispatch(addIsDirectOnly(stringified_key));
      }
    },
    [dispatch, selected_value]
  );

  return (
    <CheckboxLabel
      outlined
      shape="square"
      label={label}
      value={value}
      checked={value}
      disabled={disabled}
      startIcon={<LightningMD color="icon.special.opaque" />}
      onChange={() => handleDirectOnlyCheckboxChange(bucket_data?.key)}
    />
  );
};
